import { useContext } from "react";
import DataContext from "./data-context";

export function useDataContext() {
  return useContext(DataContext);
}
